<div
	mediaFileDragDrop
	class="drop-zone"
	[class.default]="state === FileUploadBoxState.DEFAULT"
	(filesChange)="onFilesChange($event)"
	(uploadErrorEvent)="onUploadError($event)"
	(click)="onClick($event, fileInputElement)"
	[state]="state"
	[allowed_extensions]="allowed_extensions()"
	[allowed_number]="allowed_number()"
	[allowed_max_size]="allowed_max_size()"
	[mediaFiles]="mediaFiles$ | async"
	[filesInUpload]="filesInUpload$ | async"
>
	<!-- description from host -->
	<ng-content></ng-content>
	<!-- hover -->
	@if (state === FileUploadBoxState.DEFAULT) {
		<fa-icon [icon]="faPlusCircle" class="fileselect"></fa-icon>
	}
	<!-- dragover -->
	<fa-icon [icon]="faArrowAltCircleDown" class="filedrop"></fa-icon>
	<!-- progress spinner -->
	<!-- Note: we need two spinners here
  one with value 100 to have the background circle
  and the other one to show processing
  -->
	@if (state === FileUploadBoxState.UPLOADING) {
		<div class="spinner">
			<mat-progress-spinner
				class="bg-spinner"
				[diameter]="60"
				mode="determinate"
				[value]="100"
			></mat-progress-spinner>
			<mat-progress-spinner
				class="top-spinner"
				[diameter]="60"
				style="margin-top: -60px"
				mode="determinate"
				[value]="completion"
			></mat-progress-spinner>
			<p class="state">
				{{ "Uploading" | translate }}
				@if (fileQueue.length) {
					<span> ({{ "QueuedFileUploads" | translate }}: {{ fileQueue.length }}) </span>
				}
			</p>
		</div>
	}

	@if (state === FileUploadBoxState.UPLOADED) {
		<fa-icon
			[icon]="isAllowedToRemoveFile() && isHovered() ? faCircleXmark : faCheckCircle"
			[ngClass]="
				isAllowedToRemoveFile() && isHovered() ? 'fileuploaded-hovered' : 'fileuploaded'
			"
			(click)="removeAttachedFile()"
		>
		</fa-icon>
		<p class="filename">{{ filename }}</p>
	}

	<input
		#fileInputElement
		(change)="onChange($event)"
		style="display: none"
		type="file"
		[multiple]="allowed_number() > 1"
	/>

	@if (state === FileUploadBoxState.DEFAULT && uploadRequired()) {
		<label>*{{ "uploadRequired" | translate }}</label>
	}
</div>
